import Vue from 'vue'
import Vuetify from 'vuetify' //https://vuetifyjs.com
import 'vuetify/dist/vuetify.min.css'
import VJstree from 'vue-jstree' //https://www.npmjs.com/package/vue-jstree

import App from './App.vue'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(VJstree)


new Vue({
  render: function (h) { return h(App) }
}).$mount('#app')
